import Uploader from './Uploader.vue';
export default Uploader;
